import { DashboardRoutes } from "@/router";
import { buildUrl } from "@payping/utilities-shared/url";
import { URLS } from "@payping/utilities-shared/consts";

interface ChangeLogType {
  links: string[][];
  version: string;
}

// for each new release note there should be an entry inside changeLog and another one inside translation files
// changeLog contains links to changed pages
// translations contain release note texts
export const changeLog: ChangeLogType[] = [
  {
    links: [[DashboardRoutes.settings.terminal.url]],
    version: "1.8.0",
  },
  {
    links: [[DashboardRoutes.user.referral.url]],
    version: "1.7.0",
  },
  {
    links: [[]],
    version: "1.6.5",
  },
  // TODO: The link have to use blog utils constant
  {
    links: [[buildUrl(URLS.BLOG_URL, "enamad").toString()]],
    version: "1.6.0",
  },
  {
    links: [[DashboardRoutes.user.upgrade.url]],
    version: "1.5.10",
  },
  {
    links: [[DashboardRoutes.home.overview.url], [DashboardRoutes.mySale.report.url]],
    version: "1.3.0",
  },
  {
    links: [[]],
    version: "1.2.0",
  },
  {
    links: [[], [], []],
    version: "1.1.0",
  },
  {
    links: [
      [DashboardRoutes.home.overview.url],
      [DashboardRoutes.connections.developers.root.url],
      [DashboardRoutes.connections.root.url],
      [],
      [],
      [],
      [DashboardRoutes.profile.root.url, DashboardRoutes.settings.root.url],
      [],
    ],
    version: "1.0.0",
  },
];
